export default __webpack_public_path__ + "static/media/certificado-semana-trauma.8ee77ddc.svg";